import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { publicUnsubscribe } from '../services/mailingService';

const Unsubscribe = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [status, setStatus] = useState('pending');
    const [message, setMessage] = useState('Procesando baja...');

    useEffect(() => {
        const doUnsub = async () => {
            try {
                const res = await publicUnsubscribe({ token });
                setStatus('success');
                setMessage(res.message || 'Te has dado de baja correctamente');
            } catch (err) {
                setStatus('error');
                setMessage(err.message || 'Error procesando la baja');
            }
        };

        if (token) doUnsub();
        else {
            setStatus('error');
            setMessage('Token inválido o ausente');
        }
    }, [token]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
            <div className="bg-white p-8 rounded-lg shadow-md max-w-lg w-full text-center">
                <h2 className="text-xl font-bold mb-4">Baja de correo</h2>
                <p className={`mb-4 ${status === 'success' ? 'text-emerald-600' : 'text-red-600'}`}>{message}</p>
                {status === 'success' ? (
                    <p className="text-sm text-slate-500">Lamentamos verte partir. Si cambias de opinión, puedes volver a suscribirte.</p>
                ) : null}
            </div>
        </div>
    );
};

export default Unsubscribe;
